// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"4edf5572","39":"c9b3f259","614":"df5ce8a9","787":"d54cd326","852":"b3dc66f7"}[chunkId] + ".chunk.js";
};